import { motion } from 'framer-motion';
import SectionHeading from '../home/SectionHeading';
import '../home/home.css';

const ease = [0.23, 1, 0.32, 1] as const;

const stackGroups = [
  {
    domain: 'Languages',
    items: ['Python', 'TypeScript', 'Rust', 'Java', 'Go', 'SQL', 'C++', 'Kotlin'],
  },
  {
    domain: 'AI / ML',
    items: ['PyTorch', 'LangChain', 'RAG', 'Vector databases', 'LLM fine-tuning', 'MLflow'],
  },
  {
    domain: 'Frameworks',
    items: ['Next.js', 'React', 'Nuxt.js', 'Express', 'Nest.js', 'Django', 'FastAPI', 'tRPC', 'GraphQL'],
  },
  {
    domain: 'Cloud & DevOps',
    items: ['AWS', 'Docker', 'Terraform', 'Ansible', 'Linux', 'GitHub Actions', 'OpenStack Swift'],
  },
  {
    domain: 'Databases',
    items: ['PostgreSQL', 'Supabase', 'MongoDB', 'Redis', 'MySQL'],
  },
  {
    domain: 'Frontend & mobile',
    items: ['React Flow', 'Vue.js', 'OpenLayers', 'Android (Kotlin)', 'Chrome extensions'],
  },
  {
    domain: 'Observability',
    items: ['Prometheus', 'Grafana', 'Sentry', 'Playwright', 'Selenium'],
  },
] as const;

type ToolsOfTradeProps = {
  embedded?: boolean;
};

const ToolsOfTrade = ({ embedded = false }: ToolsOfTradeProps) => {
  const content = (
    <>
      <SectionHeading title="Tools of the trade" />

      <div className="home-section-body">
        <motion.div
          className="home-ledger"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease }}
        >
          {stackGroups.map((group) => (
            <div key={group.domain} className="home-ledger-row">
              <span className="home-ledger-label">{group.domain}</span>
              <p className="tools-trade-items">{group.items.join(', ')}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="home-about-module tools-trade-section">{content}</div>;
  }

  return (
    <section className="home-section tools-trade-section" id="Tools">
      <div className="home-section-inner">{content}</div>
    </section>
  );
};

export default ToolsOfTrade;
